import React from 'react';

/**
 * Contrato do Clube que ainda não teve o primeiro pagamento.
 *
 * É um estado diferente do atraso: o assinante em atraso já pagou alguma vez e mantém o
 * benefício, enquanto este ainda não gerou nenhum pagamento e por isso não tem desconto.
 * Por isso o ícone é uma espera, e não o alerta vermelho da mensalidade vencida.
 */
const ClubPendingIcon = ({ className = "text-secondary ms-1", title = "Aguardando o primeiro pagamento", ...props }) => {
    return (
        <i
            className={`fa-solid fa-hourglass-half ${className}`}
            title={title}
            {...props}
        ></i>
    );
};

export default ClubPendingIcon;
